import axios from 'axios';
import { isPublicAuthPath } from './authentication/authPaths';
import { clearAuthLocalStorage } from './authentication/authStorage';

const cmsBaseUrl = '/api';

const api = axios.create({
  baseURL: cmsBaseUrl,
});

api.interceptors.response.use(
  (res) => res,
  async (error) => {
    if (error.response?.status !== 401) {
      return Promise.reject(error);
    }

    clearAuthLocalStorage();
    setApiToken();

    if (!isPublicAuthPath(window.location.pathname)) {
      window.location.replace('/login');
    }

    return Promise.reject(error);
  },
);

export function setApiToken(token) {
  if (!token) {
    delete api.defaults.headers.common['Authorization'];
    return;
  }

  api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
}

export default api;
